function routerConfig($stateProvider) {
  'ngInject';

  $stateProvider
    .state('app.reset-password', {
      url: 'reset-password',
      data:{
        login:{
          open: true,
          view: 'reset'
        }
      }
    })
    .state('app.login', {
      url: 'login',
      data:{
        login:{
          open: true,
          view: 'login'
        }
      }
    });
}
export default routerConfig;



/** WEBPACK FOOTER **
 ** ./src/app/components/loginForm/loginForm.route.js
 **/